export default __webpack_public_path__ + "static/media/whale-brand-logo.6fb550d0.png";